export default function getResource(label, vars = []) {
    const resources = {
        dontMissOut: `Don’t miss out! Join Beauty Insider, our FREE loyalty program to bank the *${vars[0]} points* from this order.`,
        dontMissOutSignIn: `Don’t miss out! Sign into your Beauty Insider account to bank the *${vars[0]} points* from this order.`,
        signIn: 'Sign In',
        createAccount: 'Create Account'
    };

    return resources[label];
}
